import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full py-4 px-6 border-t border-gray-200 bg-white/80 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="" className="h-6 w-auto" aria-hidden="true" />
          <p className="text-sm text-gray-500">© 2026 Resumemo. All rights reserved.</p>
        </div>
        <div className="flex space-x-4">
          <Link to="/team" className="text-sm text-gray-500 hover:text-primary-600 transition-colors">
            Teams
          </Link>
          <Link to="/privacy-policy" className="text-sm text-gray-500 hover:text-primary-600 transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" className="text-sm text-gray-500 hover:text-primary-600 transition-colors">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;